// extracted by mini-css-extract-plugin
module.exports = {"cartBtn":"cartBtn_cartBtn__UqKXj","primary":"cartBtn_primary__24xDb"};